import { useMemo } from 'react';

import { useApi } from '@/hooks/api';
import { JournalService } from '@/services/emotion-detector';

/**
 * Provides a memoized instance of JournalService
 */
export function useJournalService() {
	const apiRequest = useApi();

	return useMemo(() => new JournalService(apiRequest), [apiRequest]);
}
